export default __webpack_public_path__ + "static/media/bullet-bossmode.ab565900.gif";